import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex } from '@chakra-ui/react';
import history from '../../../history';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { syncActions } from '../../../actions/dictionary-values';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { LOAD_STATES } from '../../../reducers/common';
import { Form } from '../form';
const keyColumnField = {
    label: `KeyColumn`,
    key: `columnIndex`,
    name: 'keyColumn',
    helpText: 'The key column of the dictionary is used to identify a row as unique',
    placeholder: '',
    required: true,
    type: 'select',
    option: [],
    labelField: 'name',
    valueField: 'columnIndex'
};
const keyColumnFormButtons = [
    {
        buttonType: 'submit',
        buttonText: 'Next'
    },
    {
        buttonType: 'link',
        buttonText: 'cancel'
    }
];
const keyColumnForm = {
    fieldGroups: [
        {
            label: 'Select Key Column',
            fields: [
                keyColumnField
            ]
        }
    ],
    buttons: keyColumnFormButtons
};
const insertKeyColumnOptions = (cols)=>{
    keyColumnField.options = cols.map((col)=>{
        return {
            ...col,
            columnIndex: col.columnIndex.toString()
        };
    });
    return keyColumnForm;
};
const KeyColumnSelection = ()=>{
    const columnEditorState = useSelector((state)=>{
        return state.dictionaryValues.columnMetadataEditor;
    });
    const dispatch = useDispatch();
    const subformEnabler = ()=>{
        return columnEditorState.loadState !== LOAD_STATES.started;
    };
    const navigateNext = ()=>{
        const pathParts = window.location.pathname.split('/');
        const newRoute = pathParts.splice(pathParts.length);
        newRoute.push('crossMaps');
        history.push(`${newRoute.join('/')}`);
    };
    const handleAction = (event)=>{
        const { detail } = event;
        if (detail.eventType === 'cancel') {
            const pathParts = window.location.pathname.split('/');
            pathParts.pop();
            pathParts.pop();
            history.push(`${pathParts.join('/')}`);
        }
    };
    const handlePropChange = (prop, value)=>{
        dispatch(syncActions.selectKeyColumn(parseInt(value)));
    };
    const columnIndex = columnEditorState.columnMetadata.find((col)=>col.keyColumnIndicator === true)?.columnIndex.toString();
    const dataItem = {
        columnIndex
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                children: /*#__PURE__*/ _jsx(BreadCrumbsComponent, {})
            }),
            /*#__PURE__*/ _jsx(Form, {
                formDefinition: insertKeyColumnOptions(columnEditorState.columnMetadata),
                dataItem: dataItem,
                title: 'Column Metadata - Key Column',
                inline: false,
                onPropChange: handlePropChange,
                enable: subformEnabler,
                onSave: navigateNext,
                onAction: handleAction,
                errors: {
                    status: '',
                    message: null,
                    errors: [],
                    fieldErrors: {}
                }
            })
        ]
    });
};
export { KeyColumnSelection };
